import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { theme } from '@notino/react-styleguide';

import { Line } from '../../SelectedVariant/styled';
import { LineWrapper, TextIcon } from '../styled';
import {
  DiscountInfoDescription,
  VoucherDiscountIconWrapper,
  VoucherDiscountInfoFlex,
  VoucherDiscountInfoWrapper,
} from '../VoucherDiscountInfo/styled';

import { messages } from './messages';
import { Description, InfoLink, Title } from './styled';
import { IGlamourDay } from './utils';

interface IGlamourDayProps {
  glamourDay: IGlamourDay;
  hideLine?: boolean;
}

export const GlamourDay = ({ glamourDay, hideLine }: IGlamourDayProps) => (
  <>
    <VoucherDiscountInfoWrapper data-testid="glamour-day">
      <VoucherDiscountInfoFlex>
        <DiscountInfoDescription>
          <Title>
            <FormattedMessage {...messages.title} />
          </Title>
          <Description>
            <FormattedMessage
              {...messages.description}
              values={{
                a: (chunks) =>
                  glamourDay.infoPageUrl ? (
                    <InfoLink href={glamourDay.infoPageUrl}>{chunks}</InfoLink>
                  ) : (
                    chunks
                  ),
              }}
            />
          </Description>
        </DiscountInfoDescription>

        <VoucherDiscountIconWrapper>
          <TextIcon bgColor={theme.color.background.highlight}>Top!</TextIcon>
        </VoucherDiscountIconWrapper>
      </VoucherDiscountInfoFlex>
    </VoucherDiscountInfoWrapper>

    {!hideLine && (
      <LineWrapper>
        <Line />
      </LineWrapper>
    )}
  </>
);
